import EditableTable from 'records/EditableTable';

import {
  EDITABLE_TABLE_EDIT_ROW,
  EDITABLE_TABLE_EDIT_ROW_RESET,
  EDITABLE_TABLE_EDIT_ROW_COMPLETE,
  EDITABLE_TABLE_UPDATE_EDITABLE_ITEM,
  EDITABLE_TABLE_SET_UPDATING,
  EDITABLE_TABLE_UPDATE_MODIFIED,
  EDITABLE_TABLE_SET_PARTIAL_UPDATE,
  EDITABLE_TABLE_EDIT_ROW_PARTIALLY,
  EDITABLE_TABLE_UPDATE_ITEM_SOURCE,
} from 'actions/editableTable';

const initialState = new EditableTable();

const actionsMap = {
  [EDITABLE_TABLE_EDIT_ROW]: (state, action) => {
    const itemSource = state.get('itemSource');
    const updatingTimestampState = state.get('updatingTimestamp');
    const updatingRow = updatingTimestampState === action.updatingTimestamp ? false : true;
    const updatingTimestamp = updatingRow ? updatingTimestampState : null;
    return new EditableTable({
      editableRowId: action.editableRowId,
      editableItem: action.editableItem,
      itemSource,
      updatingRow,
      updatingTimestamp,
    });
  },
  [EDITABLE_TABLE_EDIT_ROW_PARTIALLY]: (state, action) => {
    const itemSource = state.get('itemSource');
    const updatingTimestampState = state.get('updatingTimestamp');
    const updatingRow = updatingTimestampState === action.updatingTimestamp ? false : true;
    const updatingTimestamp = updatingRow ? updatingTimestampState : null;
    // will reserve the editable fields
    const { editableItem, reserveFields } = action;
    let updatedItem = editableItem;
    reserveFields.forEach(field => {
      updatedItem = updatedItem.set(field, state.get('editableItem').get(field));
    });
    return new EditableTable({
      editableRowId: action.editableRowId,
      editableItem: updatedItem,
      itemSource,
      updatingRow,
      updatingTimestamp,
    });
  },
  [EDITABLE_TABLE_EDIT_ROW_RESET]: () => {
    return new EditableTable();
  },
  [EDITABLE_TABLE_EDIT_ROW_COMPLETE]: () => {
    return new EditableTable();
  },
  [EDITABLE_TABLE_UPDATE_EDITABLE_ITEM]: (state, action) => {
    const newState = state.updateEditableItemRecordValue(action.key, action.value);
    return newState;
  },
  [EDITABLE_TABLE_SET_UPDATING]: (state, action) => {
    let newState = state.set('updatingRow', action.updatingRow);
    newState = newState.set('updatingTimestamp', action.updatingTimestamp);
    return newState;
  },
  [EDITABLE_TABLE_UPDATE_MODIFIED]: (state, action) => {
    const newState = state.set('anyFieldModified', action.anyFieldModified);
    return newState;
  },
  [EDITABLE_TABLE_SET_PARTIAL_UPDATE]: (state, action) => {
    const newState = state.set('partiallyUpdate', action.partiallyUpdate);
    return newState;
  },
  [EDITABLE_TABLE_UPDATE_ITEM_SOURCE]: (state, action) => {
    const newState = state.set('itemSource', action.itemSource);
    return newState;
  },
};

export default function editableTable(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
